import getRemoteConfigValue from 'utils/firebase/remoteConfig';

export function getProtooUrl({
  token,
  forceH264,
  forceVP9,
  communicationServer,
}) {
  const urlValue = getRemoteConfigValue('communication_server_url');
  const defaultCommunicationServerUrl = urlValue.asString();

  const communicationServerUrl =
    typeof communicationServer === 'string' &&
    communicationServer !== '' &&
    communicationServer
      ? communicationServer
      : defaultCommunicationServerUrl;

  const portValue = getRemoteConfigValue('communication_server_port');
  const communicationServerPort = portValue.asString();

  let url = `wss://${communicationServerUrl}:${communicationServerPort}/?token=${token}`;

  if (forceH264) {
    url = `${url}&forceH264=true`;
  } else if (forceVP9) {
    url = `${url}&forceVP9=true`;
  }

  const __sourceUrl = (typeof urlValue.getSource === 'function') ? urlValue.getSource() : '(no getSource)';
  const __sourcePort = (typeof portValue.getSource === 'function') ? portValue.getSource() : '(no getSource)';
  console.log('[WEBGL_DBG] urlFactory: protoo url=' + url + ' urlSource=' + __sourceUrl + ' portSource=' + __sourcePort);

  return url;
}
